import React from "react";
import { FadeComponent } from "../fadediv/FadeComponent";
import Utils from "../../utils/Utils";

export const SqRecord = ({ show = true }) => {
  return (
    <FadeComponent show={show}>
      <>
        <div className="container stats-explained">
          <h2 style={{ marginBottom: "30px" }}>SQ Rim & 3 Rate</h2>

          <div className="gray-background-container" style={{ marginBottom: "50px" }}>
            <h5 className="sq-points-tittle" style={{ marginBottom: "30px" }}>
              SQ Rim & 3 Rate
            </h5>

            <p className="text-template">
              The rate at which each team gets a shot at the rim (drive to the basket or layup) or a three point
              attempt. These are the two most valuable shots in half court offense!
            </p>
            <p className="bold-text">
              For instance,
              <br />
              40 (Rim & 3 attempts) / 70 (Total Possessions) = 57% Rim & 3
            </p>
            <div className="row align-items-center">
              <div className="box col-lg-12">
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th className="w-50">
                          Rating
                          {/* <i className="fa fa-sort-desc" aria-hidden="true" /> */}
                        </th>
                        <th className="w-50">
                          Rim & 3 Rate
                          {/* <i className="fa fa-sort-desc" aria-hidden="true" /> */}
                          <div className="tooltipCon">
                            <b className="d-block">ShotQuality Rim & 3</b>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Excellent</td>
                        <td>80% or more</td>
                      </tr>
                      <tr>
                        <td>Great</td>
                        <td>75%</td>
                      </tr>
                      <tr>
                        <td>Above Average</td>
                        <td>70%</td>
                      </tr>
                      <tr>
                        <td>Average</td>
                        <td>65%</td>
                      </tr>
                      <tr>
                        <td>Below Average</td>
                        <td>60%</td>
                      </tr>
                      <tr>
                        <td>Poor</td>
                        <td>55%</td>
                      </tr>
                      <tr>
                        <td>Awful</td>
                        <td>50% or less</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container stats-explained">
          <div className="gray-background-container" style={{ marginBottom: "150px" }}>
            <h5 className="sq-points-tittle" style={{ marginBottom: "30px" }}>
              SQ Rim & 3 SQPPP
            </h5>
            <p className="text-template">
              It is the calculated efficiency of each team is when they attempt a shot at the rim (drive to the basket
              or layup) or a three point attempt.
            </p>

            <div className="row align-items-center">
              <div className="box col-lg-12">
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th className="w-50">
                          Rating
                          {/* <i className="fa fa-sort-desc" aria-hidden="true" /> */}
                        </th>
                        <th className="w-50">
                          Rim & 3 SQPPP
                          {/* <i className="fa fa-sort-desc" aria-hidden="true" /> */}
                          <div className="tooltipCon">
                            <b className="d-block">ShotQuality Rim & 3 SQPPP</b>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Excellent</td>
                        <td>1.30 or more</td>
                      </tr>
                      <tr>
                        <td>Great</td>
                        <td>1.25</td>
                      </tr>
                      <tr>
                        <td>Above Average</td>
                        <td>1.20</td>
                      </tr>
                      <tr>
                        <td>Average</td>
                        <td>1.15</td>
                      </tr>
                      <tr>
                        <td>Below Average</td>
                        <td>1.10</td>
                      </tr>
                      <tr>
                        <td>Poor</td>
                        <td>1.05</td>
                      </tr>
                      <tr>
                        <td>Awful</td>
                        <td>1.00 or less</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </FadeComponent>
  );
};
